// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { familyOrder } from '../constants/families';
import MPFamilyContainer from '../containers/MPFamilyContainer';
import MPHeaderContainer from '../containers/MPHeaderContainer';
import MPNotificationContainer from '../containers/MPNotificationContainer';
import MPWelcomeContainer from '../containers/MPWelcomeContainer';

import MPViewWrapper from './common/MPViewWrapper';

const Wrapper = styled.div``;

const StyledMPHeaderContainer = styled(MPHeaderContainer)`
  margin-bottom: 1em;
`;

const MPListFamilies = styled.div``;

const StyledMPFamilyContainer = styled(MPFamilyContainer)`
  display: inline-block;
  margin-bottom: 1em;
  width: 50%;

  &:nth-child(even) {
    padding-left: 2em;
  }
`;

type MPHomeProps = {
  className?: string;
};

const MPHome = ({ className = '' }: MPHomeProps) => {
  return (
    <MPViewWrapper className={className}>
      <Wrapper>
        <StyledMPHeaderContainer />
        <MPListFamilies>
          {familyOrder.map((familyId) => {
            return <StyledMPFamilyContainer key={familyId} familyId={familyId} />;
          })}
        </MPListFamilies>
      </Wrapper>
      <MPWelcomeContainer />
      <MPNotificationContainer />
    </MPViewWrapper>
  );
};

export default MPHome;
